/**
 * useAuth Hook
 * Exports useAuth hook that uses AuthProvider from app/providers
 * This is the public API for auth - features should import from here, not from app/providers
 */

import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../../../../app/providers/AuthProvider';

/**
 * useAuth - Hook to access auth context
 * Uses AuthProvider from app/providers
 * This is the public API for authentication in features
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
